import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Container, Grid, GridColumn, Heading, Image, Text } from '@teliaee/design-system';
import Config from '../Config';
import useStores from '../stores/UseStores';
import ErrorUtil from '../util/ErrorUtil';

const NotFound = observer((): React.JSX.Element => {
  const {
    routeStore,
    translateStore: { translate },
  } = useStores();

  React.useEffect(() => {
    const error = new Error('404 page not found');
    error.stack = routeStore.pathname;
    ErrorUtil.pushErrorToTeliaRumAndLog(error);
  }, []);

  return (
    <Container>
      <Grid align={['start-xs']}>
        <GridColumn width={['sm-6', 'lg-5']}>
          <Image srcset="https://www.telia.ee/images/pages/etc/404/404-pic-desktop+mob@4x.png" width={400} align="center" role="presentation" shape="rounded" />
        </GridColumn>
        <GridColumn width={['sm-6', 'lg-5']} align={['middle-xs']}>
          <Text>
            <Heading level={1} className="c-brand-primary-text-subtle">
              {translate('404.new.title')}
            </Heading>
            <Heading level={2} className="h4">
              {translate('404.new.text')}
            </Heading>
            <p>
              {translate('404.new.goBack')}
              <Button link={true} text={translate('404.new.teliaPage')} isUnderlined={true} url={Config.teliaWebUrl} />
            </p>
          </Text>
        </GridColumn>
      </Grid>
    </Container>
  );
});

export default NotFound;
